

export const FETCH_ALL_SETTINGS_DATA_REQUEST = 'FETCH_ALL_SETTINGS_DATA_REQUEST';
export const FETCH_ALL_SETTINGS_DATA_SUCCESS = 'FETCH_ALL_SETTINGS_DATA_SUCCESS';
export const FETCH_ALL_SETTINGS_DATA_FAILURE = 'FETCH_ALL_SETTINGS_DATA_FAILURE';


export const FETCH_SETTINGS_DATA_BY_ID_REQUEST = 'FETCH_SETTINGS_DATA_BY_ID_REQUEST';
export const FETCH_SETTINGS_DATA_BY_ID_SUCCESS = 'FETCH_SETTINGS_DATA_BY_ID_SUCCESS';
export const FETCH_SETTINGS_DATA_BY_ID_FAILURE = 'FETCH_SETTINGS_DATA_BY_ID_FAILURE';

export const CREATE_SETTINGS_REQUEST = 'CREATE_SETTINGS_REQUEST';
export const CREATE_SETTINGS_SUCCESS = 'CREATE_SETTINGS_SUCCESS';
export const CREATE_SETTINGS_FAILURE = 'CREATE_SETTINGS_FAILURE';

export const CREATE_SETTINGS_MASTER_USERFORM = 'CREATE_SETTINGS_MASTER_USERFORM';

export const RESET_SETTINGS_USERFORM = 'RESET_SETTINGS_USERFORM';

export const UPDATE_SETTINGS_REQUEST = 'UPDATE_SETTINGS_REQUEST';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_FAILURE = 'UPDATE_SETTINGS_FAILURE';

export const DELETE_SETTINGS_REQUEST = 'DELETE_SETTINGS_REQUEST';
export const DELETE_SETTINGS_SUCCESS = 'DELETE_SETTINGS_SUCCESS';
export const DELETE_SETTINGS_FAILURE = 'DELETE_SETTINGS_FAILURE';